import { AptosClient } from 'aptos'
import { CHAIN_NAME, MODULE_ADDRESS } from 'config'

import { getDateWithOffset } from './getDateWithOffset.ts'

const fn = `${MODULE_ADDRESS}::claim::get_timings`

/**
 * Fetches the start and end times for a claim from the Aptos blockchain.
 *
 * This function queries the Aptos blockchain for the start and end times of a claim using a predefined function.
 * It then adjusts these times based on the local timezone offset and returns them.
 *
 * @returns A Promise that resolves to an object containing the start and end dates of the claim.
 *          The dates are adjusted to the local timezone.
 * @throws Will throw an error if the fetch operation fails.
 */
export const getTimeClaim = async () => {
  const nodeUrl = `https://fullnode.${CHAIN_NAME}.aptoslabs.com/v1`
  const client = new AptosClient(nodeUrl)

  return client
    .view({ arguments: [], function: fn, type_arguments: [] })
    .then((data: string[]) => {
      const [start, end] = data

      const timezoneOffsetInMinutes = new Date().getTimezoneOffset()

      const startDate = getDateWithOffset(start)
      const endDate = getDateWithOffset(end)

      console.log('start', +start, startDate, '\nend', +end, endDate, '\ntimezone', timezoneOffsetInMinutes, 'min')

      return {
        end: endDate,
        start: startDate,
      }
    })
    .catch((error) => {
      console.error('Failed to fetch date:', error)
      throw error
    })
}
